/**
 * Moved to `shared/src/review/url-detail-onpage-issues.ts` so the review surface and the server-side
 * export read one copy of this logic. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  NOT_SURFACED_STORED_ISSUE_TEXTS,
  buildOnpageTechnicalIssueViews,
  surfacedStoredIssues
} from '@taptimize/shared/dist/review/url-detail-onpage-issues';
export type {
  OnpageIssueView
} from '@taptimize/shared/dist/review/url-detail-onpage-issues';
